import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-xs max-w-[600px] leading-5 text-gray-700',
    container: 'container flex flex-col gap-1 has-[*]:my-15'
  },
  variants: {
    hidden: {
      true: 'hidden'
    }
  },
  defaultVariants: {
    hidden: false
  }
});
